import React, { useEffect, useState } from "react"
import "../../styles/Components/storeresubmission.css"
import { Store } from "../../Apis/storeApis"
import { useSelector } from "react-redux"
import { translations } from "../../utils/Translation/staticTranslation"

const StoreResubmission = ({ rejectedRequestId }) => {
  const user = useSelector((state) => state.user.user)

  const [comments, setComments] = useState([])

  useEffect(() => {
    const fetchComments = async () => {
      try {
        const response = await Store.getComments(rejectedRequestId)
        if (response.status === 200) {
          setComments(response.data)
        }
      } catch (error) {
        console.error("Error Get Comments:", error)
      }
    }
    fetchComments()
  }, [rejectedRequestId])

  const latestComment = comments
    ?.filter((comment) => comment.author !== user.id)
    .pop()
  const lang = localStorage.getItem("language") || "ar"
  const store = translations[lang]?.StorePage

  return (
    <div className="store-resubmission">
      <div className="d-flex">
        <div className={`${lang === "ar" ? "ml-10" : "mr-10"} `}>
          <img src="/icons/infoyellow.svg" alt="" />
        </div>
        <div>
          <div className="mb-10">
            <p className="text-14 text-141414 mb-0 font-600">
              {" "}
              {store?.resubmission_remarks}
            </p>
          </div>
          <div className="row">
            <div className="mb-23">
              <span className="text-14 text-5C5C5C font-400">
                {latestComment?.comment_text}
              </span>
              <p className="text-13 text-141414 mb-0 font-600">
                {latestComment?.time}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default StoreResubmission
